import { Paper, Skeleton, Typography } from "@mui/material";
import FinancialsDataGrid from "components/ui/atoms/formFields/FinancialsDataGrid";
import { useCompany } from "models/companies/apiCompany";

const FinancialsWidget = ({ companyId }) => {
  const {
    data: company,
    isLoading,
    isError,
    isSuccess,
    error,
  } = useCompany(companyId);

  if (isLoading) return <Skeleton variant="rectangular" height={150} />;
  if (isError) return <Typography variant="body2">{error.message}</Typography>;

  return (
    isSuccess && (
      <Paper sx={{ width: "-webkit-fill-available", p: 2 }}>
        <Typography variant="subtitle2" sx={{ pb: 2 }}>
          Financials
        </Typography>
        {company.financial_data ? (
          <FinancialsDataGrid value={company.financial_data} disabled />
        ) : (
          <Typography variant="body2" sx={{ color: "primary.main" }}>
            No financial data
          </Typography>
        )}
      </Paper>
    )
  );
};

export default FinancialsWidget;
